import { Injectable } from '@angular/core';
import {throwError} from 'rxjs';
import { UserCredentials } from '../../models/userCredential.model';
import { DATES, CUSTOMER_tYPES , PUIS_ORDER_TYPE, SALES_ORDER_TYPE} from '../../common/constants/defines';
import { TrackingService } from '@vfde-fe/ngx-lib/plugins/tracking';
import { LOGIN_SUCCESS, LOGIN_METHOD, REVOCATION_NOT_APPLICABLE, REVOCATION_CLEANUP_NOENTITLED, ORIGINAL_SALES_STATUS_CLEANUP_NOENTITLED } from '../../../config/tracking.defines';
import * as dayjs from 'dayjs';
import { AfterSalesLoginSuccess } from '../../interfaces/after-sales-login-success.interface';
import { OrderDetailedService } from '../../../app/shared/services/order-details.service';
import { CustomerTypes, Delivery } from '../../models/delivery.model';
import { ReturnsEntitled } from '../../models/position.model';
import isEmpty from 'lodash/isEmpty';
import { catchError, map } from 'rxjs/operators';
/** LoginService */
@Injectable()
export class LoginService {
    /**
     * loginNumber represents the number of login trials
     */
    public loginNumber: number = 1;
    /** secondDeliveryAllowed */
    public secondDeliveryAllowed: boolean = false;
    /**
     * loginDate - date of login
     */
    public loginDate;
    /**
     * used in tracking- is yes if user logged in within 14 days of orderDate and no otherwise
     */

    /** logingMethod */
    public logingMethod;
    /** loginPeriod */
    public loginPeriod;
    /** cleanUpNoReturnsEntitledSimEsimOnlyFlag */
    public cleanUpNoReturnsEntitledSimEsimOnlyFlag: boolean;
    /** cleanUpNoReturnsEntitleFlag */
    public cleanUpNoReturnsEntitleFlag: boolean;
    /**
     * create instant from LoginService
     * @param {OrderDetailedService} OrderDetailedService
     * @param {TrackingService} trackingService
     */
    public constructor ( private OrderDetailedService: OrderDetailedService, private trackingService: TrackingService) {
    }

    /**
     * get data after sumbit user credentials
     * @param {UserCredentials} userCredentials
     */
    public getMappedOrderDetails (userCredentials: UserCredentials) {

        return this.OrderDetailedService.getMappedOrderDetails(userCredentials)
            .pipe(map((response) => {
                this.checkCleanUpNoReturnsEntitledSimEsimOnly(response);
                this.prepareTrackingObject(response, userCredentials);

                return response;
            }), catchError((reason) => {
                this.loginNumber++;

                return throwError(reason);
            }));
    }

    /**
     * prepare tracking object after logging in successfully
     * login period is set to yes when difference between orderDate and login date is within 14 days
     * @param delivery delivery object
     * @param orderDetails order details object
     */

    /** prepareTrackingObject */
    public prepareTrackingObject (delivery: Delivery, userCredentials: UserCredentials) {
        this.loginDate = dayjs(new Date()).format(DATES.DATE_FORMAT_YMD);
        const loginDate = new Date(this.loginDate);
        const orderDate = new Date(delivery.orderDate);
        const timeDiff = Math.abs(orderDate.getTime() - loginDate.getTime());
        const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

        const positionKeys = Object.keys(delivery.positions);
        const groupKeys = delivery.groups[Object.keys(delivery.groups)[0]];
        const positions = !isEmpty(delivery.positions) ? delivery.positions[positionKeys[0]][0] : groupKeys[Object.keys(groupKeys)[0]][0].position;

        if (positions.returnsEntitled !== ReturnsEntitled.Z) {
            if (diffDays <= 14) {
                this.loginPeriod = LOGIN_SUCCESS.LOGIN_PERIOD.WITHIN_14_DAYS;
            } else {
                this.loginPeriod = LOGIN_SUCCESS.LOGIN_PERIOD.NOT_WITHIN_14_DAYS;
            }
        } else {
            this.loginPeriod = LOGIN_SUCCESS.LOGIN_PERIOD.HAPPINESS;

        }
        const revocationPeriod = positions.returnsEntitled ? positions.returnsEntitled.toLocaleLowerCase() : delivery.logistics.position ? REVOCATION_NOT_APPLICABLE : REVOCATION_CLEANUP_NOENTITLED;
        const originalSaleStatus = this.cleanUpNoReturnsEntitleFlag ? ORIGINAL_SALES_STATUS_CLEANUP_NOENTITLED : delivery.status;
        if (userCredentials.deliveryNumber.toString().startsWith('0')) {
            this.logingMethod = LOGIN_METHOD.MSISDN;
        } else {
            this.logingMethod = LOGIN_METHOD.DELIVERY_NUMBER;
        }
        const lineOfCustomer = delivery.mappedCustomerType !== CustomerTypes.Elephant ? CUSTOMER_tYPES.CONSUMER : CUSTOMER_tYPES.ENTERPTISE;
        this.trackingObjectLoginSuccess({ loginMethod: this.logingMethod,
             customerType: delivery.customerType,
              channel: delivery.channel,
               originalSaleShop: delivery.salesOrganization,
                originalSaleStatus: originalSaleStatus,
                loginNumber: this.loginNumber,
                 loginPeriod: this.loginPeriod,
                  lineOfCustomer: lineOfCustomer,
                   revocationPeriod: revocationPeriod,
            orderType: (delivery.salesOrderType == PUIS_ORDER_TYPE.PUIS) ? SALES_ORDER_TYPE.PUIS : SALES_ORDER_TYPE.NOT_APPLICABLE,
             postalShopping: delivery.isPostalShopping ? 'yes' : 'no',
        });        this.loginNumber = 1;
    }

    /**
     * trackingObjectLoginSuccess calls trackCustomAction in tracking service
     * @param afterSalesLoginSuccess tracking object after login success
     */
    public trackingObjectLoginSuccess (afterSalesLoginSuccess: AfterSalesLoginSuccess) {
        this.trackingService.trackCustomAction(LOGIN_SUCCESS.STORE_AFTER_SALES_LOGIN, afterSalesLoginSuccess);
    }
    /**
     * checkCleanUpNoReturnsEntitledSimEsimOnly
     * @param delivery Delivery
     */
      public checkCleanUpNoReturnsEntitledSimEsimOnly (delivery: Delivery) {
        const positionKeys = delivery.positions && Object.keys(delivery.positions);
        const groupKeys = delivery.groups && delivery.groups[Object.keys(delivery.groups)[0]];
        const positions = !isEmpty(delivery.positions) ? delivery.positions[positionKeys[0]][0] : groupKeys[Object.keys(groupKeys)[0]][0].position;
        const customerType = delivery.mappedCustomerType;
        if ((!positions.returnsEntitled || positions.returnsEntitled.length === 0) && (!delivery.logistics.position)) {
            this.cleanUpNoReturnsEntitleFlag = true;
            if (customerType == CustomerTypes.Tiger || customerType == CustomerTypes.NeoTiger) {
            this.cleanUpNoReturnsEntitledSimEsimOnlyFlag = true;
        }
    }
}
}
